package kz.dentalcrm.app.di

import kz.dentalcrm.app.data.network.AuthApi
import kz.dentalcrm.app.data.network.DiagnosisApi
import kz.dentalcrm.app.data.network.InitialInspectionApi
import kz.dentalcrm.app.data.network.MainApi
import kz.dentalcrm.app.data.network.PositionsApi
import kz.dentalcrm.app.data.network.QuickRepliesApi
import kz.dentalcrm.app.data.network.ServicesApi
import kz.dentalcrm.app.data.network.TreatmentApi
import org.koin.dsl.module

fun apiServicesModule() = module {
    factory<AuthApi> { AuthApi(httpClient = get()) }
    factory<MainApi> { MainApi(httpClient = get(), storage = get()) }
    factory<ServicesApi> { ServicesApi(httpClient = get(), storage = get()) }
    factory<DiagnosisApi> { DiagnosisApi(httpClient = get(), storage = get()) }
    factory<TreatmentApi> { TreatmentApi(httpClient = get(), storage = get()) }
    factory<PositionsApi> { PositionsApi(httpClient = get(), storage = get()) }
    factory<InitialInspectionApi> { InitialInspectionApi(httpClient = get(), storage = get()) }
    factory<QuickRepliesApi> { QuickRepliesApi(httpClient = get(), storage = get()) }
}